import actionTypes from 'SRC/modules/redux/actionTypes'

export const setError = error => ({
  type: actionTypes.SET_EDIT_AD_ERROR,
  payload: error
})
